import React from 'react';
import pittMdPlus from '../../Assests/Events/pittMdPlus.svg';
import pitsburgUniversity from '../../Assests/Events/University-pitsburug.svg';
import '../../Styles/Events.scss';
import { useNavigate } from 'react-router-dom';

function Event() {
    const navigate = useNavigate();

    const eventData = [
        {
            id: 1,
            image: pitsburgUniversity,
            clickable: true,
            title: 'One-Day Symposium on P5 Healthcare with Multi-Omics and AI-Driven Personalization',
            description: 'Vizzhy Inc. and the University of Pittsburgh are proud to announce the Global 1 Million Multi-Omics Precision Medicine Initiative (1M-PMI) - a transformative commitment to collect and analyze multi-omics and longitudinal health data across 1 million individuals worldwide.',
            location: 'The University Club, University of Pittsburgh, Oakland Campus',
            time: '8:00 AM - 8:00 PM',
            date: '1st May, 2025',
        },
        {
            id: 2,
            image: pittMdPlus,
            clickable: true,
            title: 'Pitt Med + AI: Transforming Global Health Symposium',
            description: 'The Pitt Med + AI: Transforming Global Health Symposium is a daylong  event during which Anantha Shekhar, senior vice chancellor for the  health sciences and John and Gertrude Petersen Dean of the School of  Medicine, and Joan Gabel, chancellor of the University of Pittsburgh  since 2023, will announce a partnership among the University of  Pittsburgh School of Medicine, Vizzhy Longevity Inc., and other global  leaders in AI health care technology.',
            location: 'The University Club, University of Pittsburgh, Oakland Campus',
            time: '8:00 AM - 8:00 PM',
            date: '1st May, 2025',
        },
    ];

    const handleCardClick = (id) => {
        if (id === 1) {
            navigate('/event/event-pitsburg');
        } else if (id === 2) {
            navigate('/event/event-pitmdplus');
        }
    };

    return (
        <div className="mt-5 pt-5 p-2 p-md-5">
            {eventData.map(({ id, image, clickable, title, description, location, time, date }) => (
                <div key={id}>
                    {/* Layout 1: Image on top for all screen sizes */}
                    <div
                        className="card p-2 shadow mt-4 event-card d-block d-lg-none"
                        style={{ cursor: clickable ? 'pointer' : 'default' }}
                    >
                        <div className="row g-0" onClick={() => handleCardClick(id)}>
                            <div className="col-12">
                                <img src={image} alt="Event" className="img-fluid w-100" />
                            </div>
                            <div className="col-12 p-3">
                                <div className="pitsburg-headline text-body fs-5 fs-md-4 fs-lg-3">{title}</div>
                                <div>
                                    <span className="Finished-status-pill py-1 px-4 mt-2 d-inline-block">
                                    Finished
                                    </span>
                                </div>
                                <div className="pitsburg-subline mt-3">{description}</div>
                                <div className="pitsburg-subline-colorText mt-2">{location}</div>
                                <div className="mt-2 pt-2 mt-md-4 pt-md-4 d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
                                    {/* <div
                                        className="d-inline-flex primary-btn py-2 px-4 careers-contact-us contact-us align-items-center mt-4"
                                        onClick={(e) => {
                                            e.stopPropagation(); // Prevent card click
                                            window.open('https://www.health.pitt.edu/pitt-med-ai-transforming-global-health-symposium?utm_source=hsstratcomm_eblast&utm_medium=email&utm_campaign=ai_symposium_25&utm_content=invitation#Details', '_blank');
                                        }}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <div>Join Now</div>
                                        <span className="material-symbols-outlined ms-1">
                                            arrow_right_alt
                                        </span>
                                    </div> */}
                                    <div className="d-flex flex-column flex-sm-row gap-2">
                                        <div className="time-status-pill py-2 px-4 d-flex align-items-center">
                                            <span className="material-symbols-outlined me-1" style={{ fontSize: '18px' }}>schedule</span>
                                            {time}
                                        </div>
                                        <div className="time-status-pill py-2 px-4 d-flex align-items-center">
                                            <span className="material-symbols-outlined me-1" style={{ fontSize: '18px' }}>calendar_month</span>
                                            {date}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Layout 2: Side-by-side for desktop */}
                    <div
                        className="card p-2 shadow mt-5 event-card d-none d-lg-block"
                        style={{ cursor: clickable ? 'pointer' : 'default' }}
                    >
                        <div className="row g-3 align-items-start p-3" onClick={() => handleCardClick(id)}>
                            <div className="col-12 col-md-3 text-center text-md-start order-1 order-md-0">
                                <img src={image} alt="Event" className="img-fluid" />
                            </div>
                            <div className="col-12 col-md-9 order-0 order-md-1">
                                <div className="pitsburg-headline">{title}</div>
                                <div>
                                    <span className="Finished-status-pill py-1 px-4 mt-2 d-inline-block">
                                    Finished
                                    </span>
                                </div>
                                <div className="pitsburg-subline mt-3">{description}</div>
                                <div className="pitsburg-subline-colorText mt-2">{location}</div>
                                <div className="mt-2 pt-2 mt-md-4 pt-md-4 d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
                                    {/* <div
                                        className="d-inline-flex primary-btn py-2 px-4 careers-contact-us contact-us align-items-center mt-4"
                                        onClick={(e) => {
                                            e.stopPropagation(); // Prevent card click
                                            window.open('https://www.health.pitt.edu/pitt-med-ai-transforming-global-health-symposium?utm_source=hsstratcomm_eblast&utm_medium=email&utm_campaign=ai_symposium_25&utm_content=invitation#Details', '_blank');
                                        }}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <div>Join Now</div>
                                        <span className="material-symbols-outlined ms-1">
                                            arrow_right_alt
                                        </span>
                                    </div> */}
                                    <div className="d-flex flex-column flex-sm-row gap-2">
                                        <div className="time-status-pill py-2 px-4 d-flex align-items-center">
                                            <span className="material-symbols-outlined me-1" style={{ fontSize: '18px' }}>schedule</span>
                                            {time}
                                        </div>
                                        <div className="time-status-pill py-2 px-4 d-flex align-items-center">
                                            <span className="material-symbols-outlined me-1" style={{ fontSize: '18px' }}>calendar_month</span>
                                            {date}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default Event;